import { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import {
  createDepartmentMaster,
  getDepartmentById,
  departmentDataManage,
  departmentMasterData,
  updateDepartmentMaster,  
} from "./departmentData";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { useLoading } from "../../../context/LodingContext";
import { useMutation } from "@apollo/client";
import Swal from "sweetalert2";

const DepartmentMasterForm = () => {
  const [departmentData, dispatch] = useReducer(
    departmentDataManage,
    departmentMasterData,
  );
  const [inputDisble, setInputDisble] = useState(false);
  
  const [createDepartment, { loading, error }] = useMutation(
    createDepartmentMaster,
  );
  const [UpdateDepartment] = useMutation(updateDepartmentMaster);
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();
  const location = useLocation();
  
  const formType = location?.state?.type;
  const formValue = location?.state?.data;
  const rowId = location?.state?.rowId;

  useEffect(() => {
    if (rowId) {
      fetchById(rowId);
    }
  }, [rowId]);

  const fetchById = async (id) => {
    try {
      const response = await request(BASEURL, getDepartmentById, {
        departmentId: id,
      });
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    if (formValue) {
      dispatch({
        value: formValue?.departmentName,
        name: "departmentName",
      });
    }
  }, [formValue]);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  const checkAllFields = () => {
    if (departmentData.departmentNameStatus === "success") {
      return true;
    } else {
      return false;
    }
  };

  const handleAdd = async () => {
    setCirleLoading(true);

    try {
      const response = await createDepartment({
        variables: {
          input: {
            departmentName: departmentData?.departmentName,
          },
        },
      });

      const res = response?.data?.createDepartment?.success;
      const message = response?.data?.createDepartment?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/department-masters");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdateDepartment = async () => {
    setCirleLoading(true);

    try {
      const response = await UpdateDepartment({
        variables: {
          input: {
            id: formValue?.id,
            departmentName: departmentData?.departmentName,
          },
        },
      });

      const res = response?.data?.updateDepartment?.success;

      const message = response?.data?.updateDepartment?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/department-masters");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Department Master Details"
                    : formType == "edit"
                      ? "Edit Department Master Details"
                      : "View Department Master Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={departmentData?.departmentName}
                  name="departmentName"
                  placeholder="Enter Department name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "departmentName",
                    })
                  }
                  error={
                    departmentData.departmentDataStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    departmentData.departmentDataStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/department-masters")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={formType == "add" ? handleAdd : handleUpdateDepartment}
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default DepartmentMasterForm;
